<template>
    <div class="vx-row px-4" id="schedule_booking">
        <div class="vx-card p-4 vx-col w-full">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full my-auto" @click="closeDatepicker()">
                            <span class="font-bold">Tuần: {{ this.weekOfYear }}</span>
                        </div>
                        <div class="vx-col w-full md:w-1/2 sm:w-1/2">
                            <div class="w-full flex">
                                <vs-button icon-pack="feather" icon="icon-chevron-left"
                                           class="sm:ml-auto my-auto round size-button mr-2"
                                           @click="previousDate(); closeDatepicker()">

                                </vs-button>
                                <vx-tooltip text="Chọn ngày" position="top" class="my-auto">
                        <span class="my-auto cursor-pointer font-bold" @click="showDatepicker()">
                            {{ this.date.selectDateFormat }}
                        </span>
                                </vx-tooltip>

                                <vx-tooltip text="Chọn ngày" position="top" class="my-auto">
                                    <feather-icon icon="CalendarIcon" class="action-success ml-2 mt-1"
                                                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                  @click="showDatepicker()"/>
                                </vx-tooltip>
                                <vs-button icon-pack="feather" icon="icon-chevron-right"
                                           class="round size-button ml-2 my-auto"
                                           @click="nextDate(); closeDatepicker()"></vs-button>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row -mt-4">
                        <div class="vx-col ml-auto">
                            <datepicker :highlighted="highlighted" class="searchDate" :language="vi"
                                        :format="'dd/MM/yyyy'" v-model="dateSelected" data-vv-validate-on="input"
                                        ref="datepick">
                            </datepicker>
                        </div>
                    </div>

                    <div class="vx-row" @click=" closeDatepicker()">
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                            <label class="vs-input--label">Chi nhánh</label>
                            <v-select class="w-full" v-model="selectedBranch" :options="branchOptions"
                                      :clearable="false">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                            <label class="vs-input--label">Phòng ban</label>
                            <v-select class="w-full" v-model="selectedDepartment" :options="departmentOptions"
                                      :clearable="false">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 sm:mt-2 mt-2">
                            <label class="vs-input--label">Bác sĩ</label>
                            <v-select class="w-full" v-model="selectedDoctor" :options="doctorOptions"
                                      :clearable="false">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 sm:mt-2 mt-2">
                            <label class="vs-input--label">Khách hàng</label>
                            <v-select class="w-full" v-model="selectedCustomer" :options="paginated"
                                      :clearable="false" :filterable="false"
                                      @open="onOpen"
                                      @close="onClose"
                                      @search="searchCustomer">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                <template #list-footer>
                                    <li ref="load" class="loader">
                                        Loading more options...
                                    </li>
                                </template>
                            </v-select>
                        </div>
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-2 mt-2">
                            <label class="vs-input--label">Trạng thái</label>
                            <v-select class="w-full" v-model="selectedStatus" :options="statusOptions"
                                      :clearable="false"></v-select>
                        </div>

                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-1/2 sm:mt-2">
                            <vs-button @click="searchBooking" color="primary" iconPack="feather" icon="icon-search"
                                       class="mt-6">Tìm kiếm
                            </vs-button>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-1/2 lg:mt-2 sm:-mt-2">
                            <div class="lg:float-right md:float-left sm:float-left float-right">
                                <vs-button color="primary" iconPack="feather" icon="icon-plus"
                                           class="mt-6 text-center"
                                           @click="createdBooking" v-if="isPermissionCreateBooking">Đặt lịch
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-card mt-4 p-4 vx-col w-full">
            <div @click=" closeDatepicker()" class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap">
                        <div class="cmt_bg mt-2">
                            <span class="text">Tổng số lịch hẹn: {{ bookingTotal }}</span>
                        </div>
                        <div class="cmt_bg mt-2">
                            <span class="bg_pending color"></span>
                            <span class="text">Chờ xử lý: {{ bookingPending }}</span>
                        </div>
                        <div class="cmt_bg mt-2">
                            <span class="bg_confirm color"></span>
                            <span class="text">Xác nhận: {{ bookingConfirm }}</span>
                        </div>
                        <div class="cmt_bg mt-2">
                            <span class="bg_complete color"></span>
                            <span class="text">Hoàn thành: {{ bookingComplete }}</span>
                        </div>
                        <div class="cmt_bg mt-2">
                            <span class="bg_cancel color"></span>
                            <span class="text">Hủy: {{ bookingCancel }}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full" v-if="dataBookingSchedule.length > 0">
                    <div id="schedule" class="">
                        <div class="sc_menu">
                            <div class="sc_header_cell" style="width: 250px;"><span>&nbsp;</span></div>
                            <div class="sc_header" :style="{ width: `${setWidthSchedule}px !important` }">
                                <div class="sc_header_date_scroll" style="display: flex;">
                                    <!-- <div class="sc_date " data-date="2022/02/10" style="cursor: pointer; width: 7103px;"></div> -->
                                </div>
                            </div>
                            <br class="clear">
                        </div>
                        <div class="sc_menu flex">
                            <div class="sc_header_cell" style="width: 250px;">
                                <div style="padding-top:10px" class="text-center">Bác sĩ &amp; Thời gian</div>
                                <span>&nbsp;</span>
                            </div>
                            <div class="sc_header" :style="{ width: `${setWidthSchedule}px !important` }">
                                <div class="sc_header_scroll" id="sc_header_scroll"
                                     :style="{ width: '7140px', left: `${headerLeft}px` }">
                                    <div class="sc_header_time" style="width: 7140px;">
                                        <div v-for="(item, index) in headers" :key="index">
                                            <div class="sc_time" style="width: 419px;">{{ item }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br class="clear">
                        </div>
                        <div class="sc_wrapper mt-4">
                            <div class="sc_data" :style="{ width: '250px', height: `${heightTable}px`, }">
                                <div class="sc_data_scroll"
                                     :style="{ width: '250px', height: `${heightTable}px`, }">
                                    <div v-for="(item, index) in dataBookingSchedule" :key="index">
                                        <div class="timeline" :style="{ height: `${item.top}px`, }">
                                        <span :style="{ height: `${item.top}px` }" class="doctor_data_fa">
                                            <div class="doctor_data_child">
                                                <img :src="item.image ? item.image : imgDefault" class="resource-image">
                                                <span class="resource-name">{{ item.fullName }}
                                                    <span>{{ item.departmentName }}<br>{{ item.organizationBranchName }}</span>
                                                </span>
                                            </div>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sc_main_box" id="sc_main_box"
                                 :style="{ width: `${setWidthSchedule}px !important` }"
                                 v-on:scroll="scrollHeader">
                                <div class="sc_main_scroll" style="width: 7105px;">
                                    <div class="sc_main">
                                        <div v-for="(item, index) in dataBookingSchedule" :key="index">
                                            <div class="timeline ui-droppable"
                                                 :style="{ height: `${item.top}px`, }">
                                                <div v-for="(data, ind) in item.bookingService" :key="ind">
                                                    <div
                                                        :class="{ 'bg_cancel': data.status === 4, 'bg_complete': data.status === 3, 'bg_confirm': data.status === 2, 'bg_pending': data.status === 1 }"
                                                        :style="{ left: `${data.start * 7}px`, width: `${data.time * 7}px`, height: '70px', top: `${data.top}px` }"
                                                        class="sc_Bar ui-draggable ui-draggable-handle ui-resizable"
                                                        @click=" showDetail(data)" @mouseover="isHover = true"
                                                        @mouseout="isHover = false">
                                                        <span class="text">
                                                            <span class="task_title">{{ data.name }} <br> {{
                                                                    data.loyaltyCustomerName
                                                                }} <br>
                                                                [{{ data.startTime }}]
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br class="clear">
                        </div>
                        <div>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <vs-popup class="holamundo" :title="isUpdateBooking ? 'Chi tiết lịch hẹn' : 'Tạo mới lịch hẹn'"
                  :active.sync="openPopupCreateBooking" id="popup_booking">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label required">Chi nhánh</label>
                    <v-select v-model="selectedBranchCreate" :options="branchCreateOptions" :clearable="false"
                              v-validate="'required'" name="branch" :disabled="isUpdateBooking">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                </div>
                <div class="vx-col w-full mt-6" v-if="!isUpdateBooking">
                    <vs-radio v-model="customerRadioType" vs-value="3" class="mr-4" :disabled="isUpdateBooking">
                        Khách hàng đã có thông tin
                    </vs-radio>
                    <vs-radio v-model="customerRadioType" vs-value="4" :disabled="isUpdateBooking">
                        Khách hàng chưa có thông tin
                    </vs-radio>
                </div>
                <div class="vx-col w-full mt-4" v-if="customerRadioType == 3">
                    <label class="vs-input--label required">Khách hàng</label>
                    <v-select class="w-full" v-model="selectedCustomerCreate" :options="paginatedCreate"
                              :clearable="false" :filterable="false"
                              @open="onOpenCreate"
                              @close="onCloseCreate"
                              @search="searchCustomerCreate" v-validate="'required'" name="customer"
                              :disabled="isUpdateBooking">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        <template #list-footer>
                            <li ref="loadCreate" class="loader">
                                Loading more options...
                            </li>
                        </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('customer') }}</span>
                </div>
                <div class="vx-col w-full mt-4 px-8" v-if="customerRadioType == 4">
                    <div class="vx-row info-customer py-4">
                        <div class="vx-col w-full">
                            <h4>Thông tin khách hàng</h4>
                        </div>
                        <div class="vx-col lg:w-1/2 w-full mt-4">
                            <label class="vs-input--label required">Họ và tên</label>
                            <vs-input class="w-full" v-model="customerInfo.fullName" v-validate="'required'"
                                      name="fullName"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                        </div>
                        <div class="vx-col lg:w-1/2 w-full mt-4">
                            <label class="vs-input--label required">Số điện thoại</label>
                            <vs-input class="w-full" v-model="customerInfo.phoneNumber" name="phoneNumber"
                                      v-validate="{regex: /(0[3|5|7|8|9])+([0-9]{8})\b/, numeric: true, required: true}"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                        </div>
                        <div class="vx-col lg:w-1/2 w-full mt-4">
                            <label class="vs-input--label required">{{ $t('menuCustomer.gender') }}</label>
                            <v-select class="w-full" v-model="customerInfo.gender" :options="genderOptions"
                                      name="gender"
                                      :reduce="item => item.value" v-validate="'required'"
                                      :clearable="false"></v-select>
                            <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                        </div>
                        <div class="vx-col lg:w-1/2 w-full mt-4">
                            <label class="vs-input--label required">Nguồn khách hàng</label>
                            <v-select class="w-full" v-model="customerInfo.selectedLoyaltyCustomerSource"
                                      :options="sourceCustomerOptions" name="sourceType"
                                      :reduce="item => item.value" v-validate="'required'"
                                      :clearable="false"></v-select>
                            <span class="text-danger text-sm">{{ errors.first('sourceType') }}</span>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">Phân loại KH</label>
                            <v-select class="w-full" v-model="customerInfo.selectedCustomerType"
                                      :options="typeCustomerOptions" name="typeCustomer"
                                      :reduce="item => item.value" :clearable="false"></v-select>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">Địa chỉ</label>
                            <vs-input class="w-full" v-model="customerInfo.fullAddress" v-validate="'required'"
                                      name="fullAddress"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('fullAddress') }}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full mt-6">
                    <vs-radio v-model="packageType" vs-value="1" class="mr-4" :disabled="isUpdateBooking"
                              @change="changeSelectType">Nhóm dịch vụ
                    </vs-radio>
                    <vs-radio v-model="packageType" vs-value="2" :disabled="isUpdateBooking"
                              @change="changeSelectType">Gói dịch vụ
                    </vs-radio>
                </div>
                <div class="vx-col w-full mt-4" v-if="packageType == 1">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <label class="vs-input--label required">Nhóm dịch vụ</label>
                            <v-select v-model="selectBeautyService" :options="beautyServiceData" :clearable="false"
                                      v-validate="''" name="nameServiceType" :disabled="isUpdateBooking">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                            <!-- <span class="text-danger text-sm">{{ errors.first('nameServiceType') }}</span> -->
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">Dịch vụ</label>
                            <v-select v-model="selectBeautyServicePackage" :options="beautyServicePackageOptions"
                                      :clearable="false" v-validate="''" name="nameServicePacks"
                                      :disabled="isUpdateBooking">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                            <!-- <span class="text-danger text-sm">{{ errors.first('nameServicePacks') }}</span> -->
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">Bác sĩ</label>
                            <v-select class="w-full" v-model="selectedDoctorCreate" :options="doctorCreateOptions"
                                      :clearable="false" v-validate="''" name="doctor"
                                      :disabled="isUpdateBooking && (checkStatus === 3 || checkStatus === 4)">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors.first('doctor') }}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full mt-4" v-if="packageType == 2">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <label class="vs-input--label required">Gói dịch vụ</label>
                            <v-select v-model="selectedComboService" :options="beautyComboService"
                                      :clearable="false"
                                      v-validate="''" name="comboService" :disabled="isUpdateBooking">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                            <!-- <span class="text-danger text-sm">{{ errors.first('comboService') }}</span> -->
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-1/2 mt-4">
                    <label class="vs-input--label">Ngày</label>
                    <div class="w-full">
                        <datepicker :highlighted="highlighted" class="w-full" :language="vi"
                                    :disabled="isUpdateBooking" :format="'dd/MM/yyyy'" v-model="selectDate"
                                    data-vv-validate-on="input" ref="datepickBooking" v-validate="'required'"
                                    name="time">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-1/2 mt-4">
                    <label class="vs-input--label">Giờ</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectTime"
                                    class="w-full vs-inputx vs-input--input normal" name="time"
                                    :disabled="isUpdateBooking && (checkStatus === 3 || checkStatus === 4)"/>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-4" v-if="isUpdateBooking">
                    <label class="vs-input--label">Trạng thái</label>
                    <v-select v-model="statusBeautyBooking" :options="statusCreateOptions" :clearable="false"
                              v-validate="''" name="status"
                              :disabled="isUpdateBooking && (checkStatus === 3 || checkStatus === 4)">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full mt-4" v-if="isUpdateBooking && selectedStatusBeautyValue === 4">
                    <label class="vs-input--label required">Lý do hủy</label>
                    <vs-textarea class="w-full" v-model="cancelReason"/>
                </div>
                <div class="vx-col w-full mt-4">
                    <div class="flex flex-wrap float-right">
                        <vs-button color="primary" class="mt-6 text-center mr-2"
                                   @click="saveBooking"
                                   v-if="(isUpdateBooking && isPermissionUpdateBooking) || (!isUpdateBooking && isPermissionCreateBooking)"
                                   :disabled="!validateForm || checkStatus === 3 || checkStatus === 4">
                            {{ isUpdateBooking ? 'Cập nhật' : 'Tạo mới' }}
                        </vs-button>
                        <vs-button color="warning" type="border" class="mt-6 text-center"
                                   @click=" openPopupCreateBooking = false">Hủy
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale';
import vSelect from 'vue-select';
import authConfig from '@/../auth_config.json';
import imgDefault from '../../../../assets/images/card/doctor-icon.webp';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import {isAPI} from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";

export default {
    data() {
        return {
            headers: ['07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
            weekOfYear: 0,
            date: {
                selectDate: null,
                selectDateFormat: null
            },
            en: en,
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            branchOptions: [],
            selectedBranchValue: null,
            headerLeft: 0,
            departmentOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                {value: null, label: 'Tất cả'},
            ],
            selectedDoctorValue: null,
            customerOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedCustomerValue: null,
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: 'Chờ xử lý'},
                {value: 2, label: 'Đã xác nhận'},
                {value: 3, label: 'Đã hoàn thành'},
                {value: 4, label: 'Hủy'},
            ],
            selectedStatusValue: null,
            dataBookingSchedule: [],
            openPopupCreateBooking: false,
            bookingServiceInfo: {
                organizationBranchId: null,
                loyaltyCustomerId: null,
                beautyBookingDetails: []
            },
            beautyServicePackageData: [],
            beautyServiceData: [],
            selectBeautyServiceValue: null,
            beautyServicePackageOptions: [],
            selectBeautyServicePackageValue: null,
            selectedDoctorCreateValue: null,
            doctorCreateOptions: [],
            selectedBranchCreateValue: null,
            selectedCustomerCreateValue: null,
            customerCreateOptions: [],
            selectDate: new Date(),
            selectTime: new Date(),
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            isUpdateBooking: false,
            branchCreateOptions: [],
            packageType: 1,
            beautyComboService: [],
            selectedComboServiceValue: null,
            imgDefault: null,
            statusBeautyBookingOptions: [
                {value: 1, label: 'Chờ xử lý'},
                {value: 2, label: 'Xác nhận'},
                {value: 3, label: 'Đã hoàn thành'},
                {value: 4, label: 'Hủy'},
            ],
            selectedStatusBeautyValue: null,
            idBeautyBooking: null,
            setWidthSchedule: 0,
            idDetails: null,
            statusCreateOptions: [],
            cancelReason: null,
            checkStatus: null,
            heightTable: 0,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            bookingTotal: 0,
            bookingPending: 0,
            bookingConfirm: 0,
            bookingComplete: 0,
            bookingCancel: 0,
            isHover: false,
            ind: null,
            //Infinite Scroll Customer filter
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 50,
            observer: null,
            limit: 50,
            search: '',
            textTypingSearch: null,
            //Infinite Scroll Customer in Popup
            pageNumberCreate: 0,
            pageSizeCreate: 50,
            observerCreate: null,
            limitCreate: 50,
            searchCreate: '',
            textTypingSearchCreate: null,
            customerRadioType: '3',
            customerInfo: {
                fullName: null,
                fullAddress: null,
                gender: null,
                selectedCustomerType: null,
                selectedLoyaltyCustomerSource: null,
                phoneNumber: null,
            },
            genderOptions: [
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            sourceCustomerOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn nhân sự'},
                {value: 4, label: 'Nguồn khác'},
            ],
            typeCustomerOptions: [
                {value: 4, label: 'Khách hàng mới đến tư vấn'},
                {value: 5, label: 'Khách hàng đến mua mỹ phẩm'},
            ],
            typingSearchCustomer: null,
            typingSearchCustomerCreate: null,
            showListCustomer: false,
            showListCustomerCreate: false,
        }
    },

    components: {
        Datepicker,
        vSelect,
        imgDefault,
        flatPickr,
    },

    computed: {
        dateSelected: {
            get() {
                return this.date.selectDate;
            },
            set(obj) {
                this.date.selectDate = obj;
                this.date.selectDateFormat = moment(this.date.selectDate).format("DD/MM/YYYY");
                this.weekOfYear = this.getWeekNumber(this.date.selectDate);
            }
        },
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getDepartment();
                this.getCustomer(true);
                this.getDoctor(true);
            }
        },
        selectedDepartment: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value === this.selectedDepartmentValue)),
                    value: this.departmentOptions.find(x => x.value === this.selectedDepartmentValue)
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.getDoctor(true);
            }
        },
        selectedDoctor: {
            get() {
                return {
                    label: this.getLabelString(this.doctorOptions.find(x => x.value === this.selectedDoctorValue)),
                    value: this.doctorOptions.find(x => x.value === this.selectedDoctorValue)
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        selectedCustomer: {
            get() {
                return {
                    label: this.getLabelString(this.customerOptions.find(x => x.value === this.selectedCustomerValue)),
                    value: this.customerOptions.find(x => x.value === this.selectedCustomerValue)
                }
            },
            set(obj) {
                this.selectedCustomerValue = obj ? obj.value : null;
            }
        },
        selectedStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedStatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedStatusValue = obj ? obj.value : null;
            }
        },
        selectedBranchCreate: {
            get() {
                let obj = this.branchCreateOptions.find(x => x.value === this.selectedBranchCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedBranchCreateValue = obj ? obj.value : null;
                this.selectBeautyServiceValue = null;
                this.selectedComboServiceValue = null;
                if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
                if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
                this.doctorCreateOptions = [];
                await this.$validator.reset();
            }
        },
        selectBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },
        selectBeautyServicePackage: {
            get() {
                let obj = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServicePackageValue = obj ? obj.value : null;
                this.selectedDepartmentCreateValue = obj ? obj.departmentId : null;
                this.getDoctor(false);
            }
        },
        selectedDoctorCreate: {
            get() {
                let obj = this.doctorCreateOptions.find(x => x.value === this.selectedDoctorCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorCreateValue = obj ? obj.value : null;
            }
        },
        selectedCustomerCreate: {
            get() {
                let obj = this.customerCreateOptions.find(x => x.value === this.selectedCustomerCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedCustomerCreateValue = obj ? obj.value : null;
            }
        },
        selectedComboService: {
            get() {
                let obj = this.beautyComboService.find(x => x.value === this.selectedComboServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedComboServiceValue = obj ? obj.value : null;
            }
        },
        statusBeautyBooking: {
            get() {
                let obj = this.statusCreateOptions.find(x => x.value === this.selectedStatusBeautyValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedStatusBeautyValue = obj ? obj.value : null
                this.cancelReason = null;
            }
        },
        validateForm() {
            return !this.errors.any();
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },

        filteredCreate() {
            return this.customerCreateOptions;
        },
        paginatedCreate() {
            return this.filteredCreate.slice(0, this.limitCreate);
        },
    },

    watch: {
        '$store.state.windowWidth'(val) {
            this.setWidthSchedule = val - document.getElementsByClassName('vs-sidebar--items')[0].offsetWidth - 120 - 250;
        },
    },

    async created() {

        this.setWidthSchedule = window.innerWidth - 260 - 120 - 250;
        this.imgDefault = imgDefault;
        this.date.selectDate = new Date();
        this.date.selectDateFormat = moment(this.date.selectDate).format("DD/MM/YYYY");

        this.weekOfYear = this.getWeekNumber(this.date.selectDate);
        let formatDate = moment(new Date()).format('MM/DD/YYYY')
        this.dateNowFormat = new Date(formatDate);

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchCreateOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});
        await this.getCustomer(true);
        await this.getDepartment(true);
        await this.getDoctor(true);
        this.searchBooking();
    },

    methods: {
        scrollHeader() {
            this.headerLeft = this.$el.getElementsByClassName('sc_main_box')[0].scrollLeft * -1;
            this.$el.getElementsByClassName('sc_data')[0].scrollTop = this.$el.getElementsByClassName('sc_main_box')[0].scrollTop;
        },
        previousDate() {
            let prevStart = moment(this.date.selectDate).subtract(1, 'days');
            this.date.selectDate = new Date(prevStart);
            this.date.selectDateFormat = prevStart.format('DD/MM/YYYY');
            this.weekOfYear = this.getWeekNumber(this.date.selectDate);
        },
        nextDate() {
            let nextStart = moment(new Date(this.date.selectDate).setDate((this.date.selectDate).getDate() + 1));
            this.date.selectDate = new Date(nextStart);
            this.date.selectDateFormat = nextStart.format('DD/MM/YYYY');
            this.weekOfYear = this.getWeekNumber(this.date.selectDate);
        },
        getWeekNumber(d) {
            // Copy date so don't modify original
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            // Set to nearest Thursday: current date + 4 - current day number
            // Make Sunday's day number 7
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            // Get first day of year
            let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            // Calculate full weeks to nearest Thursday
            let weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
            // Return array of year and week number
            return weekNo;
        },
        closeDatepicker() {
            this.$refs.datepick.close();
        },
        showDatepicker() {
            this.$refs.datepick.showCalendar();
        },
        getDepartment() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({value: null, label: 'Tất cả'})
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getCustomer(check, dataCustomer) {
            return new Promise((resolve, reject) => {
                let url = '/loyalty/customer/find'
                if (check) {
                    if (this.textTypingSearch != this.search) {
                        this.textTypingSearch = this.search;
                        this.customerOptions = [
                            {value: null, label: 'Tất cả'}
                        ];
                    }
                    url += `?pageNumber=${this.pageNumberSelectCustomer}&pageSize=${this.pageSizeSelectCustomer}`;
                    if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
                } else {
                    if (this.textTypingSearchCreate != this.searchCreate) {
                        this.textTypingSearchCreate = this.searchCreate;
                        this.customerCreateOptions = [];
                    }
                    url += `?pageNumber=${this.pageNumberCreate}&pageSize=${this.pageSizeCreate}`;
                    if (!this.isUpdateBooking) {
                        if (this.textTypingSearchCreate) url += `&keySearch=${this.textTypingSearchCreate}`;
                    } else {
                        url += `&keySearch=${dataCustomer.fullName}`;
                    }
                }
                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        if (check) {
                            let customer = res.data.content.map(el => {
                                return {
                                    value: el.id,
                                    label: el.phoneNumber + ' - ' + el.fullName
                                }
                            });
                            this.customerOptions.push(...customer);
                        } else {
                            let customerCreate = res.data.content.map(el => {
                                return {
                                    value: el.id,
                                    label: el.phoneNumber + ' - ' + el.fullName
                                }
                            });
                            this.customerCreateOptions.push(...customerCreate);
                            // this.customerCreateOptions = [...new Set(this.customerCreateOptions)];
                        }
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        getDoctor(check) {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';

                if (check) {
                    this.doctorOptions = [];
                    if (this.selectedBranchValue) {
                        url += '?organizationBranchId=' + this.selectedBranchValue
                    }
                    if (this.selectedDepartmentValue) {
                        url += '&departmentId=' + this.selectedDepartmentValue
                    }
                } else {
                    this.doctorCreateOptions = [];
                    if (this.selectedBranchCreateValue) {
                        url += '?organizationBranchId=' + this.selectedBranchCreateValue
                    }
                    if (this.selectedDepartmentCreateValue) {
                        url += '&departmentId=' + this.selectedDepartmentCreateValue
                    }
                }

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        if (check) {
                            this.doctorOptions = res.data.data.map(el => {
                                return {
                                    value: el.id,
                                    label: el.fullName
                                }
                            });
                            this.doctorOptions.push({value: -1, label: 'Không xác định'});
                        } else {
                            this.doctorCreateOptions = res.data.data.map(el => {
                                return {
                                    value: el.id,
                                    label: el.fullName
                                }
                            });

                        }
                    }
                    if (check) this.doctorOptions.unshift({value: null, label: 'Tất cả'});
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        searchBooking() {
            let endDate = this.date.selectDate.setUTCHours(16, 59, 59, 999);
            let startDate = this.date.selectDate.setUTCHours(0, 0, 0, 0);
            let payload = {
                customerId: this.selectedCustomerValue,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranchValue,
                endDate: new Date(endDate).toISOString(),
                performerId: this.selectedDoctorValue,
                startDate: new Date(startDate).toISOString(),
                status: this.selectedStatusValue
            };
            this.dataBookingSchedule = [];
            this.bookingTotal = 0;
            this.bookingPending = 0;
            this.bookingConfirm = 0;
            this.bookingComplete = 0;
            this.bookingCancel = 0;

            this.$vs.loading();
            this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                res.data.content.map(x => {
                    if (x.beautyBookingDetails && x.beautyBookingDetails.length > 0) {
                        x.beautyBookingDetails.map(y => {
                            y.loyaltyCustomerName = x.loyaltyCustomer.fullName;
                            y.loyaltyCustomerId = x.loyaltyCustomer.id;
                            y.status = x.status;
                            if (y.performer) {
                                let org = this.branchOptions.find(t => t.value === y.performer.organizationBranchId);
                                if (org) {
                                    y.performer.organizationBranchName = org.label;
                                }
                                y.performer.departmentName = y.performer.departmentDTO ? y.performer.departmentDTO.departmentName : null;
                            }
                            let dataPerformer = {
                                fullName: y.performer ? y.performer.fullName : 'Chưa xác định',
                                departmentName: y.performer ? y.performer.departmentName : 'Chưa xác định',
                                organizationBranchName: y.performer ? y.performer.organizationBranchName : 'Chưa xác định',
                                performerId: y.performer ? y.performer.id : null,
                                image: y.performer && y.performer.fileManagers.length > 0 ? y.performer.fileManagers[0].url : null,
                                bookingService: [],
                            }
                            let beautyServicePackage = y.beautyServicePackage ? y.beautyServicePackage : y.beautyPackageCombo ? y.beautyPackageCombo : {};
                            let check = this.dataBookingSchedule.find(z => z.performerId === dataPerformer.performerId);
                            if (!check) {
                                dataPerformer.bookingService.push(beautyServicePackage);
                                this.dataBookingSchedule.push(dataPerformer);
                            } else {
                                this.dataBookingSchedule = this.dataBookingSchedule.filter(q => q.performerId !== y.performerId);
                                check.bookingService.push(beautyServicePackage);
                                this.dataBookingSchedule.push(check);
                            }

                            beautyServicePackage.loyaltyCustomerName = x.loyaltyCustomer.fullName;
                            beautyServicePackage.loyaltyCustomerId = x.loyaltyCustomer.id;
                            beautyServicePackage.status = y.status;
                            beautyServicePackage.startTime = y.startTime;
                            beautyServicePackage.endTime = y.endTime;
                            beautyServicePackage.bookingDate = y.bookingDate;
                            beautyServicePackage.idBeautyBooking = y.beautyBooking.id;
                            beautyServicePackage.time = beautyServicePackage.time ? beautyServicePackage.time : 30;
                            return y;
                        })
                    } else {
                        this.dataBookingSchedule = [];
                    }
                    return x;
                });

                // Set time details for booking
                this.dataBookingSchedule.map(el => {
                    el.bookingService.map(x => {
                        if (x.startTime) {
                            let startHour = parseInt(x.startTime.substr(0, 2));
                            let startMinutes = parseInt(x.startTime.substr(3, 2));
                            x.start = (startHour - 7) * 60 + startMinutes;

                            x.startCheck = new Date(new Date(x.bookingDate).setHours(startHour, startMinutes, 0))
                            let endHourCheck = startHour + Math.floor((startMinutes + x.time) / 60);
                            let endMinutesCheck = (startMinutes + x.time) % 60;
                            x.endCheck = new Date(new Date(x.bookingDate).setHours(endHourCheck, endMinutesCheck, 0));
                        }
                        return x;
                    })
                    return el;
                });

                this.dataBookingSchedule.map(el => {
                    el.bookingService.sort((a, b) => a.startCheck - b.startCheck);
                    return el;
                });

                // Set height for table and set top for booking
                this.heightTable = 0;
                this.dataBookingSchedule.map(x => {
                    let result = [];
                    x.top = 70;
                    x.bookingService.map(y => {
                        result = result.length > 0 ? result : x.bookingService;
                        result = result.filter(z => z.idBeautyBooking !== y.idBeautyBooking);
                        let dataCheck1 = result.filter(t => (t.startCheck <= y.startCheck && y.startCheck <= t.endCheck) || (t.startCheck <= y.endCheck && y.endCheck <= t.endCheck));
                        let dataCheck2 = result.filter(t => (y.startCheck <= t.startCheck && t.startCheck <= y.endCheck) || (y.startCheck <= t.endCheck && t.endCheck <= y.endCheck));
                        let dataCheck3 = dataCheck1.concat(dataCheck2);
                        let dataCheck = [...new Set(dataCheck3)]
                        if (dataCheck.length > 0) {
                            let dataTop = dataCheck.filter(t => t.top === 0);
                            if (dataTop.length > 0) {
                                let top = dataCheck.filter(t => t.top >= 0);
                                if (top.length > 0) {
                                    let arr = [];
                                    for (let i = 0; i <= 1000; i++) {
                                        arr.push(i * 70);
                                    }
                                    let topValue = top.map(t => t.top);
                                    let resultTop = arr.filter(num => !topValue.includes(num))
                                    y.top = resultTop[0];
                                } else {
                                    y.top = dataCheck.length * 70;
                                }
                            } else {
                                y.top = 0;
                            }
                        } else {
                            y.top = 0;
                        }
                        result.push(y);
                        x.top = y.top >= x.top ? (y.top + 70) : x.top;
                        this.bookingTotal++;
                        if (y.status === 1) this.bookingPending++;
                        if (y.status === 2) this.bookingConfirm++;
                        if (y.status === 3) this.bookingComplete++;
                        if (y.status === 4) this.bookingCancel++;
                        return y;
                    });
                    this.heightTable = this.heightTable + x.top;
                    return x;
                });

                // Take unknown to the end
                let unknown = this.dataBookingSchedule.find(x => !x.performerId);
                if (unknown) {
                    this.dataBookingSchedule = this.dataBookingSchedule.filter(x => x.performerId);
                    this.dataBookingSchedule.push(unknown);
                }

                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        createdBooking() {
            this.isUpdateBooking = false;
            this.selectedStatusBeautyValue = null;
            this.$validator.reset();
            this.openPopupCreateBooking = true;
            this.selectedBranchCreateValue = null;
            this.selectedCustomerCreateValue = null;
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;
            this.checkStatus = null;
            this.customerInfo = {
                fullName: null,
                fullAddress: null,
                gender: null,
                selectedCustomerType: null,
                selectedLoyaltyCustomerSource: null,
                phoneNumber: null,
            };
            this.customerRadioType = null;
            setTimeout(() => {
                this.customerRadioType = 3;
            }, 100)

            // this.customerCreateOptions = [];
            this.beautyServicePackageOptions = [];
            this.beautyServiceData = [];
            this.doctorCreateOptions = [];
            this.beautyComboService = [];
            this.statusCreateOptions = [];

            this.selectDate = new Date();
            this.selectTime = new Date();
            this.idDetails = null;
            this.idBeautyBooking = null;

            if (this.customerCreateOptions.length > 0) this.pageNumberCreate += 1;

            this.getCustomer(false);
        },
        getBeautyService(dataService, organizationBranchId) {
            return new Promise((resolve, reject) => {
                this.beautyServiceData = [];
                let payload = {
                    organizationBranchId: !this.isUpdateBooking ? this.selectedBranchCreateValue : organizationBranchId,
                    keySearch: dataService ? dataService.beautyService.name : null,
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    res.data.content.map(x => {
                        let data = this.beautyServiceData.find(t => t.value == x.id);
                        if (!data) {
                            let result = {
                                value: x.id,
                                label: x.code + '-' + x.name,
                            }
                            this.beautyServiceData.push(result);
                        }
                        ;
                    })
                    this.beautyServiceData = Array.from(new Set(this.beautyServiceData));
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    organizationBranchId: this.selectedBranchCreateValue,
                    beautyServiceId: this.selectBeautyServiceValue,
                    active: this.isUpdateBooking ? -1 : null,
                };
                this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackageOptions = res.data.content.map(el => {
                        return {
                            value: el.beautyServicePackage.id,
                            label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
                            departmentId: el.beautyServicePackage.departmentId,
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyComboService() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/beauty-package-combo/find-by-condition', {organizationBranchId: this.selectedBranchCreateValue}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyComboService = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        async saveBooking(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.packageType == 1 && !this.selectBeautyServicePackageValue) {
                return this.$vs.notify({
                    text: 'Dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.packageType == 2 && !this.selectedComboServiceValue) {
                return this.$vs.notify({
                    text: 'Gói dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                    color: 'danger'
                });
            }

            if (this.selectedStatusBeautyValue === 4 && !this.cancelReason) {
                return this.$vs.notify({
                    text: 'Lý do hủy là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let payload = {
                organizationBranchId: this.selectedBranchCreateValue,
                loyaltyCustomerId: this.selectedCustomerCreateValue,
                isDoctorCreate: true,
                packageType: this.packageType,
                id: this.idBeautyBooking,
                cancelReason: this.cancelReason,
                sourceCustomer: 1,
                beautyBookingDetails: [
                    {
                        beautyServicePackageId: this.selectBeautyServicePackageValue,
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorCreateValue,
                        startTime: this.selectTime,
                        beautyPackageComboId: this.selectedComboServiceValue,
                        id: this.idDetails,
                    }
                ]
            }

            if (this.customerRadioType == 4) {
                payload['fullName'] = this.customerInfo.fullName;
                payload['customerType'] = this.customerInfo.selectedCustomerType;
                payload['phoneNumber'] = this.customerInfo.phoneNumber;
                payload['gender'] = this.customerInfo.gender;
                payload['fullAddress'] = this.customerInfo.fullAddress;
                payload['loyaltyCustomerSource'] = this.customerInfo.selectedLoyaltyCustomerSource;
                payload['sourceCustomer'] = 2;
            }

            let url = '/beauty-booking/';
            if (!this.isUpdateBooking) {
                url += 'create';
                let checkDate = new Date(new Date(this.selectDate).setHours(parseInt(this.selectTime.substr(0, 2)), parseInt(this.selectTime.substr(3, 2)), 0));
                if (checkDate < new Date()) {
                    return this.$vs.notify({
                        text: 'Thời gian đặt lịch không hợp lệ!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
            }
            if (this.isUpdateBooking && this.selectedStatusBeautyValue === 1) {
                return this.$vs.notify({
                    text: 'Phải thay đổi trạng thái trước khi cập nhật!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (this.isUpdateBooking && this.selectedStatusBeautyValue === 2) {
                url += 'confirm-booking';
            }
            if (this.isUpdateBooking && this.selectedStatusBeautyValue === 3) {
                url += 'complete-booking';
            }
            if (this.isUpdateBooking && this.selectedStatusBeautyValue === 4) {
                url += 'cancel-booking';
            }

            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.$vs.notify({
                    text: `${this.isUpdateBooking ? 'Cập nhật' : 'Tạo mới'} lịch hẹn thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.openPopupCreateBooking = false;
                this.$vs.loading.close();
                this.searchBooking();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDetail(data) {
            this.openPopupCreateBooking = true;
            this.packageType = null;
            this.checkStatus = data.status;
            this.$validator.reset();
            // this.customerCreateOptions = [];
            // this.pageNumberCreate = 0;

            if (data.status === 1) {
                this.statusCreateOptions = this.statusBeautyBookingOptions.filter(x => x.value !== 3);
            } else if (data.status === 2) {
                this.statusCreateOptions = this.statusBeautyBookingOptions.filter(x => x.value !== 1);
            } else if (data.status === 3) {
                this.statusCreateOptions = this.statusBeautyBookingOptions.filter(x => x.value === 3);
            } else if (data.status === 4) {
                this.statusCreateOptions = this.statusBeautyBookingOptions.filter(x => x.value === 4);
            }

            this.$vs.loading();
            this.$crm.get(`/beauty-booking/find-by-id/${data.idBeautyBooking}`).then(async res => {
                this.cancelReason = res.data.cancelReason;
                this.isUpdateBooking = true;
                this.idBeautyBooking = data.idBeautyBooking;
                this.selectedBranchCreateValue = res.data.organizationBranchId;
                await this.getCustomer(false, res.data.loyaltyCustomer);
                this.selectedCustomerCreateValue = res.data.loyaltyCustomer.id;
                let result = res.data.beautyBookingDetails.find(x => x.beautyBooking.id === data.idBeautyBooking);
                this.idDetails = result.id;
                this.packageType = res.data.packageType;
                if (this.packageType == 1) {
                    await this.getBeautyService(res.data.beautyBookingDetails[0], res.data.organizationBranchId);
                    this.selectBeautyServiceValue = result ? result.beautyService.id : null;

                    await this.getBeautyServicePack();
                    this.selectBeautyServicePackageValue = result ? result.beautyServicePackage.id : null;
                    if (this.beautyServicePackageOptions.length > 0) {
                        // this.selectedDepartmentCreateValue = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue).departmentId;
                        this.selectedDepartmentCreateValue = result ? result.departmentId : this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue).departmentId;
                        if (this.selectedDepartmentCreateValue) {
                            await this.getDoctor(false);
                        }
                        this.selectedDoctorCreateValue = result ? result.performerId : null;
                    }
                    this.selectDate = result ? result.bookingDate : null;
                    this.selectTime = result.startTime ? result.startTime : null;
                }

                if (this.packageType == 2) {
                    await this.getBeautyComboService();
                    this.selectedComboServiceValue = result.beautyPackageCombo.id;
                    this.selectDate = result ? result.bookingDate : null;
                    this.selectTime = result.startTime ? result.startTime : null;
                }
                this.selectedStatusBeautyValue = res.data.status;
                this.$vs.loading.close();
            }).catch(err => {
                this.packageType = 1;
                this.selectedBranchCreateValue = null;
                this.selectedCustomerCreateValue = null;
                this.selectBeautyServiceValue = null;
                this.selectBeautyServicePackageValue = null;
                this.selectedDoctorCreateValue = null;
                this.selectedDepartmentCreateValue = null;
                this.selectBeautyServicePackageValue = null;
                this.selectedComboServiceValue = null;
                this.selectTime = null;
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        async changeSelectType() {
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;

            if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
            if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
        },
        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },
        isPermissionUpdateBooking() {
            return isAPI(this, constAPI.beauty_booking_update);
        },
        isPermissionDeleteBooking() {
            return isAPI(this, constAPI.beauty_booking_delete);
        },

        async onOpen() {
            this.showListCustomer = true;
            await this.$nextTick()
            this.observer.observe(this.$refs.load)
        },
        onClose() {
            this.search = '';
            this.pageNumberSelectCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 50;
                this.pageNumberSelectCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomer(true);
            }
        },

        async onOpenCreate() {
            this.showListCustomerCreate = true;
            await this.$nextTick()
            this.observerCreate.observe(this.$refs.loadCreate)
        },
        onCloseCreate() {
            this.searchCreate = '';
            this.pageNumberCreate = -1;
            this.showListCustomerCreate = false;
            this.observerCreate.disconnect();
        },
        async infiniteScrollCreate([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limitCreate += 50;
                this.pageNumberCreate += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomer(false);
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberSelectCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500)
            }
        },

        async doneTypingSearch() {
            await this.getCustomer(true);
            if (this.customerOptions.length === 1) this.selectedCustomerValue = 'null';
            await this.onOpen();
        },

        searchCustomerCreate(query) {
            if (this.openPopupCreateBooking && this.showListCustomerCreate) {
                if (this.searchCreate != query) this.pageNumberCreate = 0;
                this.searchCreate = query;
                clearTimeout(this.typingSearchCustomerCreate);
                this.typingSearchCustomerCreate = setTimeout(this.doneTypingSearchCreate, 1500)
            }
        },

        async doneTypingSearchCreate() {
            await this.getCustomer(false);
            if (this.customerCreateOptions.length === 0) this.selectedCustomerCreateValue = 'null';
            await this.onOpenCreate();
        },
    },

    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll);
        this.observerCreate = new IntersectionObserver(this.infiniteScrollCreate);
    }
}
</script>

<style lang="scss">
.searchDate input {
    visibility: hidden;
    width: 300px;
    height: 0 !important;
}

#schedule_booking {

    .hidden_details {
        display: none;
        left: 0;
        top: 0;
    }

    #schedule {
    }

    #schedule .clear {
        clear: both;
        height: 0;
        line-height: 0;
    }

    #schedule .sc_wrapper {
    }

    #schedule .sc_menu {
        width: 100%;
        height: 20px;
    }

    #schedule .sc_menu .sc_header_cell {
        float: left;
    }

    #schedule .sc_menu .sc_header {
        float: left;
        height: 33px;
        position: relative;
        overflow: hidden;
    }

    #schedule .sc_menu .sc_header .sc_time {
        text-align: center;
        border-color: #c0c0c0;
        border-left: solid 1px #FFF;
        background: rgba(var(--vs-primary), 1);
        /* background: #4488d2;
        border-color: #629ce8; */
        font-size: 14px;
        padding-top: 10px;
    }

    #schedule .sc_menu .sc_header_cell,
    #schedule .sc_data {
        float: left;
        font-weight: bold;
        /* background:#6187AE; */
        border-color: #c0c0c0;
        color: white;
        position: relative;
    }

    #schedule .sc_menu .sc_header_scroll,
    #schedule .sc_menu .sc_header_date_scroll,
    #schedule .sc_data .sc_data_scroll {
        position: absolute;
        left: 0;
        top: 0;
    }

    #schedule .sc_menu .sc_header_cell,
    #schedule .sc_header .sc_time,
    #schedule .sc_main_scroll .sc_time {
        color: #FFFFFF;
        padding: 0;
        line-height: 12px;
        height: 32px;
        display: block;
    }

    #schedule .sc_header .sc_time,
    #schedule .sc_main_scroll .sc_time {
        float: left;
    }

    #schedule .sc_main_box {
        max-height: 500px;
        overflow: hidden;
    }

    #schedule .sc_data {
        max-height: 485px;
        overflow: hidden;
    }

    #schedule .sc_main_box {
        float: left;
        overflow-y: auto;
        overflow-x: auto;
    }

    #schedule .sc_main_scroll {
    }

    #schedule .sc_main {
        position: relative;
    }

    #schedule .timeline {
        position: relative;
        padding: 0;

    }

    #schedule .sc_Bar {
        position: absolute;
        color: #fcf3f3;
        background: #ff4800;
        cursor: pointer;
        z-index: 10;
        box-shadow: 1px 1px 1px 0 #ddd;
        -moz-box-shadow: 1px 1px 1px 0 #ddd;
        -webkit-box-shadow: 1px 1px 1px 0 #ddd;
        border-radius: 2px;
        border: 1px solid #ffffff;
    }

    #schedule .ui-draggable-dragging,
    #schedule .ui-resizeable {
        z-index: 20;
    }

    #schedule .sc_Bar .head {
        display: block;
        padding: 6px 8px 0;
        font-size: 12px;
        height: 20px;
        overflow: hidden;
    }

    #schedule .sc_Bar .text {
        display: block;
        padding: 3px 5px 0;
        font-weight: 600;
        /*height:45px;*/
        overflow: hidden;
        font-size: 12px;
        font-family: "Exo", sans-serif;
    }

    #schedule .timeline,
    #schedule .sc_main .tb {
        border-bottom: solid 2px #e6e5e5;
    }

    #schedule .sc_data .timeline {
        overflow: hidden;
        background: #F5F6F9;
    }

    #schedule .sc_data .timeline span {
        padding: 10px;
        display: block;
    }

    #schedule .sc_data .timeline span.photo {
        float: left;
        width: 36px;
        height: 36px;
        padding: 10px 0 10px 10px;
    }

    #schedule .sc_data .timeline span.title {
        float: left;
        padding: 10px 0 10px 10px;
        width: 92px;
    }

    #schedule .sc_main_scroll .sc_main {
    }

    #schedule .sc_header .sc_date {
        width: 100%;
        text-align: center;
        /*background: black;*/
        color: #222222;
        font-size: 15px;
        float: left;
        line-height: 2;
        border: 0 1px 1px 1px solid white;
        font-weight: 500;
    }

    #schedule .sc_header_time {
        float: left;
    }

    #schedule .sc_time {
        font-size: 10px;
    }
}

#popup_booking {
    .info-customer {
        border: 2px solid #ccc !important;
        border-radius: 20px;
    }
}
</style>

<style lang="css">

/*Task Color*/
.bg_confirm {
    background: rgba(var(--vs-success)) !important;
}

.bg_pending {
    background: rgb(143, 143, 143) !important;
}

.bg_complete {
    background: rgba(157, 101, 201) !important;
}

.bg_cancel {
    background: rgba(var(--vs-danger)) !important;
}

.cmt_bg {
    margin-right: 50px;
}

.cmt_bg > span.color {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 5px;
    border-radius: 3px;
    margin-bottom: -2px;
}

.cmt_bg > span.text {
    font-size: 16px;
    font-weight: 500;
}

.resource-image {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: 2px solid #FFF;
    float: left;
    /*margin-top: -7px;*/
}

.doctor_data_fa {
    position: relative;
}

.doctor_data_child {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 2px;
}

.resource-name {
    float: left;
    color: #011F3B;
    padding-top: 0 !important;
}

.resource-name span {
    color: #83919E;
    font-size: 12px;
    padding: 0 !important;
    font-weight: normal;
}

.sc_Bar > .text > .task_title {
    overflow: hidden;
    display: -o-box;
    display: -moz-box;
    display: -webkit-box;
    -o-line-clamp: 3;
    -moz-line-clamp: 3;
    -webkit-line-clamp: 3;
    -o-box-orient: vertical;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
}

.timeline:before {
    background: none;
}

#schedule > .sc_menu:nth-child(2) > .sc_header_cell {
    /* background: #4488d2; */
    background: rgba(var(--vs-primary), 1);
}
</style>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>
